/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Loading_LabelInputs */

const en_media_import_loading_label = /** @type {(inputs: Media_Import_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading media`)
};

const fr_media_import_loading_label = /** @type {(inputs: Media_Import_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement du media`)
};

const de_media_import_loading_label = /** @type {(inputs: Media_Import_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medien werden geladen`)
};

const it_media_import_loading_label = /** @type {(inputs: Media_Import_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento dei supporti`)
};

const ru_media_import_loading_label = /** @type {(inputs: Media_Import_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка медиафайлов`)
};

const es_media_import_loading_label = /** @type {(inputs: Media_Import_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando medios`)
};

const zh_cn2_media_import_loading_label = /** @type {(inputs: Media_Import_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载媒体`)
};

const ja_media_import_loading_label = /** @type {(inputs: Media_Import_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアを読み込んでいます`)
};

const hi_media_import_loading_label = /** @type {(inputs: Media_Import_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया लोड हो रहा है`)
};

const pt_pt2_media_import_loading_label = /** @type {(inputs: Media_Import_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando mídia`)
};

/**
* | output |
* | --- |
* | "Loading media" |
*
* @param {Media_Import_Loading_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_loading_label = /** @type {((inputs?: Media_Import_Loading_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Loading_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_loading_label(inputs)
	if (locale === "de") return de_media_import_loading_label(inputs)
	if (locale === "it") return it_media_import_loading_label(inputs)
	if (locale === "ru") return ru_media_import_loading_label(inputs)
	if (locale === "es") return es_media_import_loading_label(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_loading_label(inputs)
	if (locale === "ja") return ja_media_import_loading_label(inputs)
	if (locale === "hi") return hi_media_import_loading_label(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_loading_label(inputs)
	return en_media_import_loading_label(inputs)
});